import { atom } from "recoil";

const levelsNameAtom = atom({
  key: "levelsNameState",
  default: localStorage.getItem("levels") ?? "",
});

export default levelsNameAtom;
